import { taskIsCancellable, statusIsCancellable } from './task-cancel';
import type { BucketableTask } from './agent-task-buckets';

/**
 * Can the person still CHANGE this task — restate it, or note something on it?
 *
 * It is the same question, and deliberately the same answer, as "can they still cancel it". A task that
 * is over is over: an edit to it changes nothing anyone will act on, and a note on it reaches no agent,
 * because the whole point of a note here is that the agent working the task reads it.
 *
 * **This is an alias, not a second rule, and that is the design.** `lib/task-cancel.ts` already folds
 * PENDING / IN_PROGRESS / WAITING / PAUSED / ACTION_NEEDED / IN_REVIEW / anything-unknown into the two
 * open buckets — over the BUCKET, never a hand-written status list — and is mirrored 1:1 by
 * `TaskCancel.swift` and `TaskCancel.kt`. A second table here would be a second answer, and the two
 * would drift the day the backend adds a status: a screen that offers a note where it hides a cancel.
 * The name exists so a call site can say what it means; the rule stays in one place.
 *
 * The server enforces the same thing independently (`taskAcceptsUserEdits` in the bridge's
 * `taskEdits.ts`, expressed as the same terminal set), so a task that settles while a form is open is
 * refused with a 409 rather than silently written.
 */
export function taskAcceptsUserEdits(task: BucketableTask): boolean {
  return taskIsCancellable(task);
}

export function statusAcceptsUserEdits(status: string | undefined): boolean {
  return statusIsCancellable(status);
}
